var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultPolicyImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(3.88px)",
      clipPath: "url(#bgblur_0_12133_4713_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-figma-bg-blur-radius": 7.76652,
    width: 50,
    height: 50,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3445 38H16.2722C15.3697 38 14.6381 37.2684 14.6381 36.366V16.7575C14.6381 15.8551 15.3697 15.1235 16.2722 15.1235H26.8934L30.9785 18.8001V36.366C30.9785 37.2684 30.2469 38 29.3445 38Z",
    fill: "#C0C2C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3662 35.5767H18.2939C17.5573 35.5767 16.9601 34.9793 16.96 34.2427V14.6343C16.96 13.8975 17.5572 13.3003 18.2939 13.3003H28.7998L32.7002 16.812V34.2427C32.7001 34.9792 32.1028 35.5765 31.3662 35.5767Z",
    fill: "white",
    stroke: "#C0C2C3",
    strokeWidth: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5193 23.653H28.5065C28.7321 23.653 28.915 23.8359 28.915 24.0615C28.915 24.2871 28.7321 24.47 28.5065 24.47H19.5193C19.2937 24.47 19.1108 24.2871 19.1108 24.0615C19.1108 23.8359 19.2937 23.653 19.5193 23.653Z",
    fill: "#ABB2B5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1531 18.7191H30.1403C30.3659 18.7191 30.5488 18.902 30.5488 19.1276C30.5488 19.3532 30.3659 19.5361 30.1403 19.5361H21.1531C20.9275 19.5361 20.7446 19.3532 20.7446 19.1276C20.7446 18.902 20.9275 18.7191 21.1531 18.7191Z",
    fill: "#ABB2B5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5191 21.1829H30.1403C30.3659 21.1829 30.5488 21.3658 30.5488 21.5914C30.5488 21.817 30.3659 21.9999 30.1403 21.9999H19.5191C19.2935 21.9999 19.1106 21.817 19.1106 21.5914C19.1106 21.3658 19.2935 21.1829 19.5191 21.1829Z",
    fill: "#ABB2B5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5193 31.653H28.5065C28.7321 31.653 28.915 31.8359 28.915 32.0615C28.915 32.2871 28.7321 32.47 28.5065 32.47H19.5193C19.2937 32.47 19.1108 32.2871 19.1108 32.0615C19.1108 31.8359 19.2937 31.653 19.5193 31.653Z",
    fill: "#ABB2B5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1531 26.7191H30.1403C30.3659 26.7191 30.5488 26.902 30.5488 27.1276C30.5488 27.3532 30.3659 27.5361 30.1403 27.5361H21.1531C20.9275 27.5361 20.7446 27.3532 20.7446 27.1276C20.7446 26.902 20.9275 26.7191 21.1531 26.7191Z",
    fill: "#ABB2B5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5191 29.1829H30.1403C30.3659 29.1829 30.5488 29.3658 30.5488 29.5914C30.5488 29.817 30.3659 29.9999 30.1403 29.9999H19.5191C19.2935 29.9999 19.1106 29.817 19.1106 29.5914C19.1106 29.3658 19.2935 29.1829 19.5191 29.1829Z",
    fill: "#ABB2B5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9149 12.9999V15.0425C28.9149 15.9449 29.6465 16.6765 30.5489 16.6765H33L28.9149 12.9999Z",
    fill: "#ABB2B5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_12133_4713_clip_path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultPolicyImg);
export default __webpack_public_path__ + "static/media/defaultPolicyImg.d88c0eae7dac581f6888b1d1cb5d46f6.svg";
export { ForwardRef as ReactComponent };